import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import { Formik, Field, Form, FormikHelpers, ErrorMessage } from "formik";
import CoordinateInput from "../../components/CoordinateInput";
import SimpleFileUpload from "@/components/upload/SimpleFileUpdate";

import {
  Button,
  Center,
  Container,
  FileListContainer,
  Input,
  InputContainer,
  InputError,
  InputLabel,
  Main,
  Select,
  Title,
  Textarea,
  Buttonback,
} from "./style";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useServiceProperty } from "../../hooks/serviceProperty";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { storageServerPath } from "../../utils/server/api";
import ModalConfirmation from "../../components/alerts/modalConfirmation";
import { useAuth } from "../../context/AuthContext";
import { useServiceHome } from "../../hooks/serviceHome";
import { PropertyLocationSelector } from "../../components/location-selector/property-location-selector";

export default function UpdateProperty() {
  const location = useLocation();

  const isEditing = location.state?.isEditing;
  const readonly = location.state?.readonly;

  const { id } = useParams();
  const [fileDelete, setFileDelete] = useState("");
  const { user } = useAuth();
  const [columnDelete, setColumnDelete] = useState("");
  const { updateProperty, editProperty, getProperty, removeFile } = useServiceProperty(id);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [files, setFiles] = useState({
    file_deed_number: "",
    file_cib: "",
    file_proof_of_residence: "",
    file_images: "",
    updated_property_registration: "", // Matrícula atualizada
    encumbrance_certificate: "", // Certidão de ônus e ações
    power_of_attorney: "", // Procuração
    itr_debt_clearance_certificate: "", // Certidão negativa de débitos do ITR
    thirty_years_certificate: "", // Certidão trintenária
    ibama_negative_certificate: "", // Certidão negativa do IBAMA
  });

  const [latitude, setLatitude] = useState(""); // Estado local para latitude
  const [longitude, setLongitude] = useState("");
  const [addressComponent, setAddressComponent] = useState<any>();
  const [property, setProperty] = useState<any>();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [detailsFile, setDetailsFile] = useState<any>({});
  const [buttonSave, setButtonSave] = useState(t("save"));
  const [clearFilesUpload, setClearFilesUpload] = useState(false);
  const [catalog, setCatalog] = useState("sell");

  const { getVegetations } = useServiceHome();
  const [vegetations, setVegetations] = useState<any[]>([]);

  useEffect(() => {
    async function fetchProperty() {
      const data = await getProperty();
      setProperty(data);
      setLatitude(data.lat);
      setLongitude(data.lng);
    }

    async function getVegetationsAll() {
      await getVegetations()
        .then((response: any) => {
          setVegetations(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    getVegetationsAll();

    function analisePage() {
      if (
        user?.user_type === "engineer" &&
        property?.engineer_connect !== null &&
        property?.engineer_connect !== user?.id
      ) {
        navigate("/news");
      }
    }

    if (!property) {
      fetchProperty();
    }

    if (property) {
      analisePage();
    }

    setCatalog(property?.status === "catalog" ? "catalog" : "sell");
  }, [property]);

  useEffect(() => {
    if (fileDelete && columnDelete) {
      removeFileApi();
    }
  }, [fileDelete, columnDelete]);

  const updateData = async () => {
    const data = await getProperty();
    setProperty(data);
  };

  const initialValues = {
    catalogs: property?.status === "catalog" ? "catalog" : "sell",
    name: property?.name || "",
    deed_number: property?.deed_number || "",
    acre: property?.acre || "",
    cib_nirf_number: property?.cib_nirf_number || "",
    description: property?.description || "",
    vegetation: property?.vegetation || "dense",
    address: property?.address || "",
    lat: property?.lat || "",
    lng: property?.lng || "",
    city: property?.city || "",
    federal_unity: property?.federal_unity || "",
  };

  const handleLatitudeChange = (value: string) => {
    setLatitude(value); // Atualiza o valor de latitude
  };

  const handleLongitudeChange = (value: string) => {
    setLongitude(value); // Atualiza o valor de longitude
  };

  const formValidation = (values: typeof initialValues) => {
    const errors: Partial<typeof initialValues> = {};

    if (!values.name || values.name.trim().length < 6) {
      errors.name = t("min_6");
    }

    if (!values.acre) {
      errors.acre = t("required");
    }

    if (!values.cib_nirf_number || values.cib_nirf_number.trim().length === 0) {
      errors.cib_nirf_number = t("required");
    }

    if (!latitude || latitude.trim().length === 0) {
      errors.lat = t("required");
    }

    if (!longitude || longitude.trim().length === 0) {
      errors.lng = t("required");
    }

    if (!values.deed_number) {
      errors.deed_number = t("required");
    }

    if (!values.description || values.description.trim().length === 0) {
      errors.description = t("required");
    }

    return errors;
  };

  const alterOpenModalDelete = async (value: boolean, status: boolean) => {
    setOpenModalDelete(value);

    if (status === true) {
      setFileDelete(detailsFile.file);
      setColumnDelete(detailsFile.column);
    }
  };

  const removeFileApi = async () => {
    await removeFile({
      file: fileDelete,
      column: columnDelete,
    })
      .then((response: any) => {
        toast.success(t("successfully"), {
          position: "top-right",
        });

        updateData();
      })
      .catch((error: Error) => {
        toast.error(error.message, {
          position: "top-right",
        });
      });
  };

  const convertDMSToDecimal = (dms: string): number => {
    const [degrees, minutes, seconds, direction] =
      dms.match(/(\d+)[° ](\d+)'(\d+)?''? ([NSEW])/i)?.slice(1) || [];

    if (!degrees || !minutes || !direction) {
      throw new Error("Formato inválido");
    }

    const decimal =
      parseFloat(degrees) +
      parseFloat(minutes) / 60 +
      parseFloat(seconds || "0") / 3600;

    // Ajusta o sinal para o hemisfério
    return direction === "S" || direction === "W" ? -decimal : decimal;
  };

  const onFileSelected = (name: string) => (file: string[]) => {
    const excludeFiles = [
      "file_deed_number",
      "file_cib",
      "file_proof_of_residence",
      "file_images",
    ];

    if (excludeFiles.includes(name)) {
      setFiles((prevFiles) => ({ ...prevFiles, [name]: file }));
      return;
    }

    setFiles((prevFiles) => ({ ...prevFiles, [name]: file[0] }));
  };

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    setButtonSave(`${t("waiting")}...`);
    values.catalogs = catalog;

    try {
      // Verifique se latitude e longitude estão no formato DMS
      let latDecimal = latitude;
      let lngDecimal = longitude;

      // Tente converter para decimal, se a inserção estiver no formato DMS
      try {
        latDecimal = convertDMSToDecimal(latitude).toString();
      } catch {
        // Caso não consiga converter, assume que já está em DD
      }

      try {
        lngDecimal = convertDMSToDecimal(longitude).toString();
      } catch {
        // Caso não consiga converter, assume que já está em DD
      }

      console.log(files);
      if (isEditing) {
        await editProperty({
          ...values,
          ...files,
          lat: latDecimal,
          lng: lngDecimal,
        });
      } else {
        await updateProperty({
          ...values,
          ...files,
          lat: latDecimal,
          lng: lngDecimal,
        });
      }

      toast.success(t("successfully"), {
        position: "top-right",
      });
      updateData();
      setClearFilesUpload(true);
    } catch (error: any) {
      if (error.response && error.response.data) {
        const errors = error.response.data.errors;
        const errors2 = error.response.data.message;

        if (errors2 && !errors) {
          toast.error(t(errors2), {
            position: toast.POSITION.TOP_CENTER,
          });
        }

        Object.keys(errors).forEach((field) => {
          errors[field].forEach((errorMessage: string) => {
            toast.error(t(errorMessage), {
              position: toast.POSITION.TOP_CENTER,
            });
          });
        });
      }
    } finally {
      setButtonSave(`${t("save")}`);
    }
  };

  return (
    <Container>
      <ToastContainer />
      <Main>
        <p>
          <Buttonback
            type={"button"}
            onClick={() => {
              navigate(`/detailsPropertySeller/${id}`);
            }}
          >
            {"< "}
            {t("back")}
          </Buttonback>
        </p>
        <Title>{t("update-property")}</Title>
        {property && (
          <>
            <Formik
              validate={formValidation}
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              <Form>
                <InputContainer>
                  <div
                    style={{
                      width: "100%",
                      paddingBottom: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    <InputLabel>{t("how_register")}</InputLabel>
                    <Field
                      as={Select}
                      type="text"
                      name="catalog"
                      value={catalog}
                      disabled={readonly}
                      required
                      onChange={(event: any) => {
                        const value = event.target.value;
                        setCatalog(value);
                      }}
                    >
                      <option key={"sell"} value={"sell"}>
                        {t("i-seller")}
                      </option>
                      <option key={"catalog"} value={"catalog"}>
                        {t("i-catalog")}
                      </option>
                    </Field>
                  </div>
                </InputContainer>
                <InputContainer>
                  <div
                    style={{
                      width: "100%",
                      paddingBottom: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    <InputLabel>{t("name")}</InputLabel>
                    <Field
                      as={Input}
                      type="text"
                      name="name"
                      minLength={6}
                      required
                      disabled={readonly}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="name" />
                    </InputError>

                    <InputLabel>{t("hectares")}</InputLabel>
                    <Field
                      as={Input}
                      type="number"
                      name="acre"
                      disabled={readonly}
                      /*required*/
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="acre" />
                    </InputError>

                    <InputLabel>{t("number-doc")}</InputLabel>
                    <Field
                      as={Input}
                      type="number"
                      disabled={readonly}
                      name="cib_nirf_number"
                      /*required={catalog === "sell"}*/
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="cib_nirf_number" />
                    </InputError>
                    <InputLabel>{t("Latitude")}</InputLabel>
                    <Field
                      name="lat"
                      type="text"
                      disabled={readonly}
                      placeholder="Ex: 12°34'56'' N"
                      value={latitude}
                      onChange={handleLatitudeChange}
                      component={CoordinateInput}
                      //    as={Input}
                      //    type="text"
                      //    name="lat"
                      //    required
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="lat" />
                    </InputError>
                    <InputLabel>{t("Longitude")}</InputLabel>
                    <Field
                      name="lng"
                      type="text"
                      disabled={readonly}
                      placeholder="Ex: 123°45'67'' W"
                      value={longitude}
                      onChange={handleLongitudeChange}
                      component={CoordinateInput}
                      // as={Input}
                      // type="text"
                      // name="lng"
                      // /*required*/
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="lng" />
                    </InputError>
                    <InputLabel>{t("deed-number")}</InputLabel>
                    <Field
                      as={Input}
                      type="number"
                      name="deed_number"
                      disabled={readonly}
                      /*required={catalog === "sell"}*/
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="deed_number" />
                    </InputError>
                  </div>
                  <div
                    style={{
                      width: "100%",

                      paddingBottom: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    <PropertyLocationSelector />
                    <InputLabel style={{ margin: "20px 0" }}>
                      <i>
                        {t("carbon_credits_available")}
                        :&nbsp;
                        {property?.carbon_credits_available}
                      </i>
                    </InputLabel>
                  </div>
                </InputContainer>
                <InputContainer>
                  <div style={{ height: "auto" }}>
                    <InputLabel>{t("description")}</InputLabel>
                    <Field
                      as={Textarea}
                      name="description"
                      disabled={readonly}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <InputError>
                      <ErrorMessage name="description" />
                    </InputError>
                  </div>
                </InputContainer>
                {user?.user_type === "engineer" && (
                  <>
                    <Button
                      type="button"
                      onClick={() => {
                        window.open(
                          "https://coletorcafir.receita.fazenda.gov.br/coletor/consulta/consultaCafir.jsf"
                        );
                      }}
                      style={{
                        marginLeft: "250px",
                      }}
                    >
                      {t("valid-cib")}
                    </Button>
                    <Button
                      type="button"
                      onClick={() => {
                        window.open(
                          "https://sncr.serpro.gov.br/ccir/consulta?windowId=516"
                        );
                      }}
                      style={{
                        marginLeft: "50px",
                      }}
                    >
                      {t("valid-ccir")}
                    </Button>
                  </>
                )}

                {/* <InputContainer>
                                    <div style={{ height: "300px" }}>
                                        <InputLabel>{t("address")}</InputLabel>
                                        <MapLocalize
                                            getAddressComponent={
                                                getAddressComponent
                                            }
                                            setAddress={property?.address}
                                            setLat={
                                                parseFloat(property?.lat) || 0
                                            }
                                            setLng={parseFloat(
                                                property?.lng || 0
                                            )}
                                            view={true}
                                        />
                                    </div>
                                </InputContainer> */}
                {isEditing === false && (
                  <InputContainer>
                    <div>
                      <InputLabel>{t("file")}</InputLabel>
                      <FileListContainer>
                        {catalog === "sell" && (
                          <>
                            <SimpleFileUpload
                              title="CCIR"
                              onFileSelected={onFileSelected("file_cib")}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("proof-residence")}
                              onFileSelected={onFileSelected(
                                "file_proof_of_residence"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("deed-file")}
                              onFileSelected={onFileSelected(
                                "file_deed_number"
                              )}
                              clearFiles={clearFilesUpload}
                            />

                            <SimpleFileUpload
                              title={t("image-property")}
                              multiple={true}
                              onFileSelected={onFileSelected("file_images")}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("updated_property_registration")}
                              onFileSelected={onFileSelected(
                                "updated_property_registration"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("file_certificate_liens")}
                              onFileSelected={onFileSelected(
                                "encumbrance_certificate"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("file_power_of_attorney")}
                              onFileSelected={onFileSelected(
                                "power_of_attorney"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("file_itr_certificate")}
                              onFileSelected={onFileSelected(
                                "itr_debt_clearance_certificate"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("file_thirty_years_certificate")}
                              onFileSelected={onFileSelected(
                                "thirty_years_certificate"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                            <SimpleFileUpload
                              title={t("file_ibama_certificate")}
                              onFileSelected={onFileSelected(
                                "ibama_negative_certificate"
                              )}
                              clearFiles={clearFilesUpload}
                            />
                          </>
                        )}
                      </FileListContainer>
                    </div>
                  </InputContainer>
                )}
                <Center>
                  <Button type="submit">{buttonSave}</Button>
                </Center>
              </Form>
            </Formik>
            <h2 style={{ marginBottom: 15, fontWeight: "bold" }}>
              {t("attachments")}
            </h2>
            <ul>
              <li>
                <a
                  href={
                    property.file_cib
                      ? storageServerPath + property.file_cib
                      : "#"
                  }
                  target={property.file_cib ? "blank" : "_self"}
                >
                  CCIR
                </a>{" "}
                {property.file_cib && (
                  <button
                    onClick={() => {
                      setOpenModalDelete(true);
                      setDetailsFile({
                        file: property.file_cib,
                        column: "file_cib",
                      });
                    }}
                    style={{
                      marginLeft: 5,
                      color: "red",
                    }}
                  >
                    {t("to-remove")}
                  </button>
                )}
              </li>
              <li>
                <a
                  href={
                    property.file_proof_of_residence
                      ? storageServerPath + property.file_proof_of_residence
                      : "#"
                  }
                  target={property.file_proof_of_residence ? "blank" : "_self"}
                >
                  {t("proof-residence")}
                </a>{" "}
                {property.file_proof_of_residence && (
                  <button
                    onClick={() => {
                      setOpenModalDelete(true);
                      setDetailsFile({
                        file: property.file_proof_of_residence,
                        column: "file_proof_of_residence",
                      });
                    }}
                    style={{
                      marginLeft: 5,
                      color: "red",
                    }}
                  >
                    {t("to-remove")}
                  </button>
                )}
              </li>
              <li>
                <a
                  href={
                    property.file_deed_number
                      ? storageServerPath + property.file_deed_number
                      : "#"
                  }
                  target={property.file_deed_number ? "blank" : "_self"}
                >
                  {t("deed-file")}
                </a>{" "}
                {property.file_deed_number && (
                  <button
                    onClick={() => {
                      setOpenModalDelete(true);
                      setDetailsFile({
                        file: property.file_deed_number,
                        column: "file_deed_number",
                      });
                    }}
                    style={{
                      marginLeft: 5,
                      color: "red",
                    }}
                  >
                    {t("to-remove")}
                  </button>
                )}
              </li>
            </ul>
            <h2
              style={{
                marginTop: 20,
                marginBottom: 15,
                fontWeight: "bold",
              }}
            >
              {t("images")}
            </h2>
            {property?.file_images
              ?.split(";")
              .map((image: any, index: number) => {
                return (
                  <ul key={index}>
                    <li>
                      <a
                        href={image ? storageServerPath + image : "#"}
                        target={image ? "blank" : "_self"}
                      >
                        <img
                          style={{
                            width: "100px",
                          }}
                          src={image ? storageServerPath + image : "#"}
                          alt=""
                        />
                      </a>{" "}
                      {image && (
                        <button
                          onClick={() => {
                            setOpenModalDelete(true);
                            setDetailsFile({
                              file: image,
                              column: "file_images",
                            });
                          }}
                          style={{
                            marginLeft: 5,
                            color: "red",
                          }}
                        >
                          {t("to-remove")}
                        </button>
                      )}
                    </li>
                  </ul>
                );
              })}
            <ModalConfirmation
              show={openModalDelete}
              alterOpenModalDelete={alterOpenModalDelete}
              message={t("delete-confirmation-file")}
            />
          </>
        )}
      </Main>
      <Footer />
    </Container>
  );
}
